var map = {
	"./hombre/colgante-cruz.png": 831,
	"./hombre/colgante-estrella-de-david.png": 832,
	"./hombre/colgante-medialuna.png": 833,
	"./mujer/colgante-cruz.png": 834,
	"./mujer/colgante-estrella-de-david.png": 835,
	"./mujer/colgante-medialuna.png": 836
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1393;